import { AbstractControl, ValidatorFn } from '@angular/forms';
import { BaseControl } from './base';
import { FormFieldSerializedValue } from '@shared/shared/form-fields';

export class ScheduleControl extends BaseControl {
  serializeValue(formControlValue: any): FormFieldSerializedValue {
    return formControlValue || null;
  }

  protected getKnownValidators(): { [key: string]: (...args: any[]) => ValidatorFn } {
    return {
      min: (minimum: number) => {
        return (control: AbstractControl): { [key: string]: any } => {
          if (control.value && control.value.length >= minimum) {
            return null;
          }

          return { minlength: { valid: false, requiredLength: minimum } };
        };
      },
    };
  }
}
